module.exports = __webpack_public_path__ + "img/product-center-normaeunified.49442660.png";